/* eslint-disable eqeqeq */
import getProp from 'lodash/get';


/**
 * 
 * @param {*} name the name / key of the value to check
 * @param {*} expectedValue the value that is used to check the condition
 * @param {*} operator which condition to apply
 * @param {*} values object in which we can find the value to check under the "name" prop
 * @returns 
 */
export function checkConditionOperand(name, expectedValue, operator, values) {
  const value = getProp(values, name);
  switch (operator) {
    case '==':
      return value == expectedValue;
    case '<=':
      return value <= expectedValue;
    case '>=':
      return value >= expectedValue;
    case '!=': 
      return value != expectedValue;
    case 'includes':
      return expectedValue.indexOf(value) > -1;
    default:
      return false;
  }

}

/**
 * @param {String} logical boolean operator that needs to be applied to an array of booleans
 * @returns {Function} a function that will apply a boolean operator to an array of functions
 */
export function getLogicalFunction(logical) {
  const normalizedLogical = logical.toLowerCase();
  if(normalizedLogical === 'and') {
    return (booleans) => booleans.reduce((result, currentBoolean) => result && currentBoolean, true);
  }

  return (booleans) => booleans.reduce((result, currentBoolean) => result || currentBoolean, false);
}

function checkOperand(operand, values) {
  if(!operand.logical) {
    return checkConditionOperand(operand.name, operand.value, operand.operator, values);
  }
  const logicalFunction = getLogicalFunction(operand.logical);
  const conditionsResult = operand.operands.map(op => checkOperand(op, values));
  return logicalFunction(conditionsResult)
}

// beware the recursion!
export function checkPrerequisite(values, prerequisites) {
  return checkOperand(prerequisites, values);
}

export function shouldShow(values, prerequisites) {
  if (!prerequisites) {
    return true;
  }

  return checkPrerequisite(values, prerequisites);
}
